UASignUserOutCtrl.$inject = ['users', 'auth', 'modalTitleID']

export default function UASignUserOutCtrl(users, auth, modalTitleID) {
  this.modalTitleID = modalTitleID
  this.users = users
  this.log = []
  this.showError = false
  this.errorMessage = ''
  this.loading = false
  this.completed = false

  this.continueAction = async function() {
    this.loading = true
    this.showError = false

    for (let i = 0; i < this.users.length; i++) {
      const u = this.users[i]
      this.log.push(`Signing out ${u.email}`)
      try {
        const resp = await auth.clearUserSessions(u.uuid)
        const sessionCount = Object.keys(resp).filter(id => resp[id].cleared).length
        this.log.push(`Signed out ${sessionCount} sessions`)
      } catch (err) {
        this.log.push(JSON.stringify(err))
      }
    }
    this.log.push('Done!')
    this.loading = false
    this.completed = true
  }.bind(this)
}
